<template>
  <div class="play-btn" @click="onClick">
    <svg viewBox="0 0 44 44" class="play-btn__border" xmlns="http://www.w3.org/2000/svg">
      <circle cx="22" cy="22" r="21" fill="none" stroke="white" stroke-width="2" />
    </svg>

    <svg viewBox="0 0 44 44" class="play-btn__hole" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <mask :id="maskId">
          <rect width="100%" height="100%" fill="white" />
          <g transform="translate(12,12)">
            <path
              d="M16.25 7.83493C17.9167 8.79718 17.9167 11.2028 16.25 12.1651L8.75 16.4952C7.08334 17.4574 5 16.2546 5 14.3301L5 5.66987C5 3.74537 7.08333 2.54255 8.75 3.5048L16.25 7.83493Z"
              fill="black"
            />
          </g>
        </mask>
      </defs>
      <circle cx="22" cy="22" r="22" fill="white" :mask="`url(#${maskId})`" />
    </svg>

    <svg viewBox="0 0 20 20" class="play-btn__icon" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.25 7.83493C17.9167 8.79718 17.9167 11.2028 16.25 12.1651L8.75 16.4952C7.08334 17.4574 5 16.2546 5 14.3301L5 5.66987C5 3.74537 7.08333 2.54255 8.75 3.5048L16.25 7.83493Z"
        fill="white"
      />
    </svg>
  </div>
</template>

<script setup lang="ts">
  import { v4 as uuidv4 } from 'uuid';

  const emit = defineEmits(['game-play']);

  const maskId = ref(`play-cutout-${uuidv4()}`);

  function onClick(e: Event): void {
    emit('game-play', e);
  }
</script>

<style src="~/assets/styles/components/button/play.scss" lang="scss" />
